import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { cloneDeep } from 'lodash-es';
import { exhaustMap } from 'rxjs';
import { BaseState, RanneyWell, RanneyWellWork, RanneyWellWorkRequest } from '../../../model';
import { RanneyWellService } from '../../../services';

export function withWorkMethods() {
  return signalStoreFeature(
    { state: type<BaseState<RanneyWell>>() },
    withMethods(store => {
      const service = inject(RanneyWellService);
      const addWork = rxMethod<{ id: number; data: RanneyWellWorkRequest }>(
        exhaustMap(({ id, data }) =>
          service.addWork(id, data).pipe(
            tapResponse({
              next: rsp =>
                patchState(store, state => {
                  const active = cloneDeep(state.active);
                  if (active && active.id === id) {
                    if (active.ranneyWellWorks) {
                      active.ranneyWellWorks.push(rsp);
                    } else {
                      active.ranneyWellWorks = [rsp];
                    }
                  }
                  return { active };
                }),
              error: console.log,
            })
          )
        )
      );
      const deleteWork = rxMethod<{ id: number; workId: number }>(
        exhaustMap(({ id, workId }) =>
          service.deleteWork(workId).pipe(
            tapResponse({
              next: () =>
                patchState(store, state => {
                  const active = cloneDeep(state.active);
                  if (active && active.id === id) {
                    active.ranneyWellWorks = active.ranneyWellWorks.filter(work => work.id !== workId);
                  }
                  return { active };
                }),
              error: console.log,
            })
          )
        )
      );
      const editWork = rxMethod<{ workId: number; data: RanneyWellWorkRequest }>(
        exhaustMap(({ workId, data }) =>
          service.editWork(workId, data).pipe(
            tapResponse({
              next: rsp => updateActiveWork(rsp),
              error: console.log,
            })
          )
        )
      );
      const updateActiveWork = (data: RanneyWellWork) =>
        patchState(store, state => {
          const active = cloneDeep(state.active);
          if (active && active.id === data.ranneyWellId) {
            const workIdx = active.ranneyWellWorks.findIndex(work => work.id === data.id);
            if (workIdx !== undefined && workIdx !== -1) {
              active.ranneyWellWorks[workIdx] = { ...data };
            }
          }
          return { active };
        });

      return { addWork, editWork, deleteWork };
    })
  );
}
